import {twMerge} from 'tailwind-merge';
import type {PressEvent} from 'react-aria';
import type {MotionProps} from 'motion/react';
import BaseButton from '../BaseButton';

export const tabContentMotionProps: MotionProps = {
  transition: {type: 'spring', duration: 0.3, bounce: 0.2},
  initial: {opacity: 0, scale: 0.97},
  animate: {opacity: 1, scale: 1},
  exit: {opacity: 0, scale: 0.97, transition: {duration: 0.1}}
};

type TabBarProps = {
  children: Array<React.ReactNode>;
  className?: string;
};

export const TabBar = ({children, className}: TabBarProps) => {
  const activeIndex = children.findIndex((child: any) => child?.props?.active);
  const numberOfTabs = children.length;

  return (
    <div
      className={twMerge(
        'relative flex rounded-full bg-(--button-bg-hover) dark:bg-(--button-bg) p-1 w-full',
        className
      )}
    >
      {activeIndex !== -1 ? (
        <div
          className="top-1 bottom-1 absolute rounded-full transition-transform duration-200 bg-(--card-color) dark:bg-(--button-bg-hover) dark:border dark:border-[rgba(255,255,255,0.06)] shadow-[0px_1px_3px_rgba(128,115,133,0.18),0px_6px_20px_rgba(128,119,133,0.15)] dark:shadow-none"
          style={{
            width: `calc(${100 / numberOfTabs}% - 4px)`,
            transform: `translateX(${activeIndex * 100}%)`,
            transitionTimingFunction: 'cubic-bezier(0.42,0,0.02,1)'
          }}
        />
      ) : null}

      {children}
    </div>
  );
};

type TabButtonProps = {
  children?: React.ReactNode;
  active?: boolean;
  size?: 'large' | 'small';
  href?: string;
  onPress?: (e: PressEvent) => void;
};

export const TabButton = ({children, size, href, onPress}: TabButtonProps) => {
  return (
    <BaseButton size={size} href={href} onPress={onPress} className="relative overflow-visible grow w-0">
      <span className="relative z-1">{children}</span>
    </BaseButton>
  );
};
